'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@/lib/auth-client';

export default function AdminGuidePage() {
  const { data: session, status } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'loading') return;
    if (!session) {
      navigate('/admin/login', { replace: true });
    }
  }, [session, status, navigate]);

  if (status === 'loading' || !session) {
    return null;
  }

  return (
    <div className="-m-8 flex min-h-[calc(100vh)] flex-col bg-white">
      <iframe
        src="/admin/guide/index.html"
        title="Panduan Pengguna CMS"
        className="h-[calc(100vh)] w-full flex-1 border-0"
      />
    </div>
  );
}
